/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
//@ts-ignore
import Slider from "react-slick";

import { IObrienProductSliderViewProps } from './obrien-product-slider';

export default (props: IObrienProductSliderViewProps) => {

    const settings = {
        centerMode: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        };

    const { slide1Image, slide2Image, slide3Image, slide4Image, slide5Image } = props;

    return (
        <section className="SliderBanners product-slider">
            <div className="App">
                <Slider {...settings}>

                    {slide1Image ? (
                    <div className="sliiick">
                        {slide1Image}
                    </div>
                    ) : null}
                    {slide2Image ? (
                    <div className="sliiick">
                        {slide2Image}
                    </div>
                    ) : null}        
                    {slide3Image ? (
                    <div className="sliiick">
                        {slide3Image}
                    </div>
                    ) : null} 
                    {slide4Image ? (
                    <div className="sliiick">
                        {slide4Image}
                    </div>
                    ) : null}     
                    {slide5Image ? (
                    <div className="sliiick">
                        {slide5Image}
                    </div>
                    ) : null}      

                </Slider>
            </div>
        </section>
    );
};
